'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

export default function AdminAccessPage() {
  const router = useRouter();

  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const ADMIN_CODE = '1017';

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    if (code.trim() === ADMIN_CODE) {
      setError('');

      localStorage.setItem('fhitzAdminAccess', 'true');

      router.push('/sign-in');
      return;
    }

    setError('Incorrect access code. Please try again.');
  }

  function handleCodeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value.replace(/\D/g, '').slice(0, 4);
    setCode(value);

    if (error) {
      setError('');
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505] px-6 text-white">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-[#101010] p-8 shadow-[0_0_50px_rgba(0,0,0,0.75)]">
        <div className="mb-8 text-center">
          <p className="mb-3 text-sm font-black uppercase tracking-[0.32em] text-[#f5c842]">
            FHITZ
          </p>

          <h1 className="text-3xl font-black tracking-[-0.04em]">
            Private Access
          </h1>

          <p className="mt-3 text-sm leading-6 text-white/60">
            FHITZ is still in private testing. Enter the access code to continue.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label
              htmlFor="admin-code"
              className="mb-2 block text-sm font-bold text-white/70"
            >
              Access Code
            </label>

            <input
              id="admin-code"
              type="password"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={4}
              value={code}
              onChange={handleCodeChange}
              placeholder="••••"
              className="w-full rounded-2xl border border-white/15 bg-black px-4 py-4 text-center text-2xl font-black tracking-[0.6em] text-white outline-none transition placeholder:text-white/20 focus:border-[#f5c842]"
            />

            {error && (
              <p className="mt-3 text-sm font-medium text-red-400">
                {error}
              </p>
            )}
          </div>

          <button
            type="submit"
            className="w-full rounded-2xl bg-[#f5c842] py-4 text-sm font-black uppercase tracking-[0.16em] text-black transition hover:bg-[#ffd65a]"
          >
            Continue
          </button>
        </form>

        <Link
          href="/"
          className="mt-6 block text-center text-sm font-medium text-white/45 transition hover:text-white"
        >
          ← Back to FHITZ home
        </Link>
      </div>
    </div>
  );
}